const BUCKET_HOST = `${process.env.NEXT_PUBLIC_STATIC_FILES_HOST}/mm-webstore`;

type GetStaticFileProps = {
  host?: string;
  path?: string;
  fileName: string;
};

const getStaticFile = ({
  host = BUCKET_HOST,
  path = null,
  fileName,
}: GetStaticFileProps): string => {
  const bucketUrl = [host, path].filter(a => a).join('/');
  return `${bucketUrl}/${fileName}`;
};

export default getStaticFile;
